import React from "react";
import PurchaseAccountList from "../Common/PurchaseAccountList";

const UserPurchaseAccountsComp = () => (
  <PurchaseAccountList role="USER" title="حساب خرید من" />
);

export default UserPurchaseAccountsComp;
